import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ClaimState } from './types';
import { RootState } from '@/types';

export const state: ClaimState = {
    data: {
      claim: undefined,
      comments: undefined,
      attachments: undefined,
      reminders: undefined,
      payments: undefined,
      interests: undefined,
    },
    loading: true,
    error: false,
    commentsError: false,
    commentsLoading: true,
    contactsError: false,
    contactsLoading: true,
    attachmentsError: false,
    attachmentsLoading: true,
    remindersError: false,
    remindersLoading: true,
    paymentsError: false,
    paymentsLoading: true,
    interestsError: false,
    interestsLoading: false,
};

const namespaced: boolean = true;

export const claim: Module<ClaimState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
